import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import api from '../api/api.js'
// removed unused `clsx` (moved to presentational components)
import { compressImage } from '../util/compressImage'
import { HOME_OPTIONS, VAC_OPTIONS, getHomeLabel, getVacLabel } from '../util/visitOptions'
import { styles } from './visit/visitStyles.js'
import VisitFilterModal from './visit/visitfilterModal.jsx'
import { getStoredVisitFilters } from '../util/visitFilters'

import { withStyles } from '@mui/styles';
import {
  AppBar,
  Autocomplete,
  Button,
  
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  
  Grid,
  IconButton,
  
  MenuItem,
  Slide,
  TextareaAutosize,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';

import { DataGrid } from '@mui/x-data-grid'

import AddCircleIcon from '@mui/icons-material/AddCircle'
import CloseIcon from '@mui/icons-material/Close'
// CloudUploadIcon moved into ClinicEditor
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import FilterListIcon from '@mui/icons-material/FilterList'
import HealingIcon from '@mui/icons-material/Healing'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
// AdfScannerIcon moved into extracted component
import InventoryIcon from '@mui/icons-material/Inventory'
import LaunchIcon from '@mui/icons-material/Launch'
import ShowChartIcon from '@mui/icons-material/ShowChart'

import AssessmentEditor from './visit/AssessmentEditor.jsx';
import ClinicEditor from './visit/ClinicEditor.jsx';
import StockSheet from './visit/StockSheet.jsx';
import VisitEditor from './visit/VisitEditor.jsx';

import VisitToolbar from './visit/VisitToolbar'
import VisitContextMenu from './visit/VisitContextMenu'
import AuthorizationDialog from './authorize/AuthorizationDialog.jsx'

const DATEOFVISIT = new Date().toJSON().slice(0, 10)
// const DATEOFVISIT = new Date().toJSON().slice(0,10).replace(/-/g,'/');

const STOMA = '2'


const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" {...props} ref={ref} />
))

const clinic0 = {
  id: 0,
  comment: '',
  date: DATEOFVISIT,
  visitId: '',
}

const assessment0 = {
  SAID: '',
  id: 0,
  // Legacy fields
  allergies: '',
  balance: '',
  ceap: '',
  comorbidities: '',
  depth: '',
  depth2: '',
  depth3: '',
  education: '',
  exudateLevel: '1',
  exudateType: '',
  healingFactors: '',
  healthEducation: '',
  infection: false,
  inflammation: false,
  length: '',
  length2: '',
  length3: '',
  margin: '',
  medInfo: '',
  medications: '',
  mobility: '',
  nutrition: '',
  painLevel: '',
  patientId: '',
  postsurgical: false,
  site: '',
  smoking: '',
  tbsa: '',
  texas: '',
  treatment: '',
  treatmentPlan: '',
  type: '',
  viability: '',
  visitId: '',
  weight: '',
  width: '',
  width2: '',
  width3: '',
  // New assessment overlay fields
  woundStartDate: '',
  treatmentStartDate: '',
  woundLocation: '',
  diabeticUlcer: false,
  pressureUlcer: false,
  venousUlcer: false,
  trauma: false,
  burns: false,
  other: false,
  surgicalProc: '',
  dstage: '',
  pstage: '',
  vstage: '',
  traumaDesc: '',
  burnDegree1: false,
  burnDegree2: false,
  burnDegree3: false,
  burnArea: '',
  cellulitis: false,
  colonised: false,
  superficial: false,
  nerds: {},
  stones: {},
  serous: '',
  sanguineous: '',
  serosang: '',
  purulent: '',
  otherDesc: '',
  // Discovery wound assessment fields
  outpatientPracticeNo: '',
  bodyAnnotation: '',
  fistulae: false,
  pilonidalCyst: false,
  skinCancer: false,
  arterialUlcer: false,
  gangren: false,
  skinGrafting: false,
  healableWound: false,
  maintenanceWound: false,
  nonHealableWound: false,
  healabilityOther: '',
  siteOfWound: '',
  sizeOfWound: '',
  woundLength: '',
  woundWidth: '',
  woundDepth: '',
  woundVolume: '',
  woundUndermining: '',
  epithelialisation: false,
  granulation: false,
  slough: false,
  blackNecrotic: false,
  overGranulating: false,
  fungating: false,
  mixedTissue: false,
  biofilm: false,
  exudateColour: '',
  exudateAmount: '',
  skinHealthy: false,
  skinDry: false,
  skinDiscoloured: false,
  skinErythema: false,
  skinMacerated: false,
  skinCallous: false,
  skinOedematous: false,
  woundPhaseInflammatory: false,
  woundPhaseProliferation: false,
  woundPhaseMaturation: false,
  painFrequency: '',
  treatmentGoals: {},
  treatmentDates: '',
  includePhoto: false,
  clinicalMotivation: false,
  quotation: false,
  assessmentSignatureDataUrl: '',
  assessmentSignatureDate: '',
}

let visit0 = {
  SAID: ' ',
  id: Math.random(),
  admin: 0,
  admnotes: '',
  createdBy: '',
  date: DATEOFVISIT,
  firstName: ' ',
  home: '215',
  medicalAid: '',
  memberNo: '',
  notes: '',
  patientName: ' ',
  seenBy: 'Ncumisa',
  vac: '100',
}

const PHONEHEIGHT = 470
const PHONEWIDTH = 450
const TABHEIGHT = 480
const TABWIDTH = 960
const PCHEIGHT = 590
const PCWIDTH = 1140

class visit extends Component {
  constructor(props) {
    super(props)

    this.state = {
      assessment: {},
      authDialogOpen: false,
      buttonText: '',
      clinic: {},
      comment: '',
      createOpen: false,
      dbinfo:'',
      deleteInfo: 0,
      deleteOpen: false,
      deleteVisitOn: false,
      deleteItemOn: false,
      displayAssessment: false,
      displayClinic: false,
      displayStockItems: false,
      displaySubMenuButtons: 0,
      displayVisit: false,
      editOpen: false,
      error: false,
      errors: [],
      fieldname: '',
      fieldvalue: null,
      filter: '',
      filterOff: true,
      filterProducts: [],
      filterModalOpen: false,
      imagesToUpload: [],
      imageLoading: false,
      images: [],
      invoiceDialogOpen: false,
      login: false,
      hMatches: window.matchMedia("(max-height: 500px)").matches,
      wMatches: window.matchMedia("(max-width: 400px)").matches,
      pcMatches: window.matchMedia("(min-width: 1200px) and (min-height: 900px)").matches,
      mouseX: null,
      mouseY: null,
      patient: {},
      patients: [],
      patientAuthMap: {},
      productLoading: false,
      products: [],
      selectedRows: null,
      stockItem: {
        id: Math.random(),
        product: '',
        visitId: '',
      },
      stockItems: [],
      title: 'Wound Solutions',
      uiLoading: false,
      vDate: DATEOFVISIT,
      viewOpen: false,
      visit: {
        vac: '1'
      },
      visitFilters: getStoredVisitFilters(),
      visitId: '',
      voiceError: '',
      voiceLoading: false,
      voiceNotes: [],
      visits: [],
    }

    this.handleDeleteVisit = this.handleDeleteVisit.bind(this)
    this.openVisitEditor = this.openVisitEditor.bind(this)
    this.openStockItemEditor = this.openStockItemEditor.bind(this)
    this.openClinicEditor = this.openClinicEditor.bind(this)
    this.openAssessmentEditor = this.openAssessmentEditor.bind(this)
    this.openAuth = this.openAuth.bind(this)
    this.closeAuth = this.closeAuth.bind(this)
    this.openFilterModal = this.openFilterModal.bind(this)
    this.closeFilterModal = this.closeFilterModal.bind(this)
    this.openInvoice = this.openInvoice.bind(this)
    this.closeInvoice = this.closeInvoice.bind(this)
    this.handleFilterChanged = this.handleFilterChanged.bind(this)

    this.assessmentEditorRef = null
  }

  sanitizeFileNamePart = (value) => String(value || '')
    .trim()
    .replace(/[^a-z0-9._-]+/gi, '_')
    .replace(/^_+|_+$/g, '')

  downloadPdfFromBase64 = (base64, fileName) => {
    const byteCharacters = window.atob(base64)
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i += 1) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    const blob = new Blob([byteArray], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }

  handleDownloadAssessmentPdf = async () => {
    if (!this.assessmentEditorRef) {
      this.setState({ dbinfo: 'Assessment content is not available yet.' })
      return
    }

    try {
      this.setState({ uiLoading: true, dbinfo: '' })
      const { generatePdfAttachmentFromElement } = await import('../util/generatePdfAttachment')
      const assessment = this.state.assessment || {}
      const mergedPatient = { ...(this.state.visit || {}), ...(this.state.patient || {}) }

      const patientName = this.sanitizeFileNamePart(mergedPatient.patientName || 'patient')
      const firstName = this.sanitizeFileNamePart(mergedPatient.firstName || '')
      const datePart = this.sanitizeFileNamePart(
        assessment.assessmentSignatureDate ||
        this.state.visit?.date ||
        new Date().toISOString().slice(0, 10),
      )
      const pdfName = `${patientName}_${firstName}_${datePart}_wound_assessment.pdf`

      const attachment = await generatePdfAttachmentFromElement(this.assessmentEditorRef, pdfName)
      if (!attachment?.attachmentBase64) {
        this.setState({ dbinfo: 'Unable to generate PDF from the assessment form.' })
        return
      }

      this.downloadPdfFromBase64(attachment.attachmentBase64, attachment.attachmentName || pdfName)
      this.setState({ dbinfo: 'Assessment PDF downloaded.' })
    } catch (error) {
      this.setState({ dbinfo: 'Failed to download assessment PDF.' })
      console.log('Failed to generate assessment PDF:', error)
    } finally {
      this.setState({ uiLoading: false })
    }
  }
  
  fetchVisits = async () => {
    const { SAID, memberNo, patientName, monthYear, recentDays } = this.state.visitFilters
    let route = `/visits/group/${this.props.groupId}`

    if (SAID) {
      route = `/visits/group/${this.props.groupId}/SAID/${encodeURIComponent(SAID)}`
    } else if (memberNo) {
      route = `/visits/group/${this.props.groupId}/memberNo/${encodeURIComponent(memberNo)}`
    } else if (patientName) {
      route = `/visits/group/${this.props.groupId}/name/${encodeURIComponent(patientName)}`
    } else if (monthYear) {
      route = `/visits/group/${this.props.groupId}/monthYear/${monthYear}`
    } else if (recentDays) {
      route = `/visits/group/${this.props.groupId}/days/${recentDays}`
    }

    if (this.state.filterModalOpen === false) {
      this.setState({  uiLoading: true })

      try {
        const response = await api.get(route);
        const visits = response.data;
        this.setState({ visits, uiLoading: false })
      } catch (error) {
        if (error.response.status === 403) {
          this.setState({login: true})
        }
        this.setState({ uiLoading: false })
      }
    }
  }

    // fetch products collection
  fetchPatients = async () => {
    try {
      const route = `/patients/group/${this.props.groupId}`
      const response = await api.get(route)
      const patients = response.data || []
      const patientAuthMap = {}
      patients.forEach((patient) => {
        patientAuthMap[patient.SAID] = {
          authStatus: patient.authStatus || 'not_started',
          authMonth: patient.authMonth || '',
        }
      })
      this.setState({ patients, patientAuthMap })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      }
      console.log(error)
    }
  }

  isAuthMonthPast = (authMonth, visitDate) => {
    if (!authMonth || authMonth.trim() === '') return false
    const parts = authMonth.split('-')
    if (parts.length !== 2) return false
    const month = parseInt(parts[0], 10)
    const day = parseInt(parts[1], 10)
    const visit = new Date(visitDate)
    if (isNaN(visit.getTime())) return false
    const year = visit.getFullYear()
    const authDate = new Date(year, month -1, day +1)
    return visit > authDate
  }

  getVisitAuthStatus = (visitSAID, visitDate) => {
    const auth = this.state.patientAuthMap[visitSAID]
    if (!auth) return 'not_started'
    const { authStatus, authMonth } = auth
    if (authStatus === 'authorized' && this.isAuthMonthPast(authMonth, visitDate)) {
      return 'not_started'
    }
    if (authStatus === 'declined') {
      return 'declined'
    }
    return authStatus
  }

  fetchProducts = async () => {
    const route = `/products/group/${this.props.groupId}`;

    this.setState({ productLoading: true })
    
    try {
      const response = await api.get(route);
      this.setState({ products: response.data, productLoading: false });
      } catch (error) {
          if (error.response.status === 403) {
            this.setState({login: true})
          }
          this.setState({ productLoading: false })
      }
  }

  openFilterModal = () => {
    this._filterChanged = false
    this.setState({ filterModalOpen: true })
  }

  closeFilterModal = () => {
    if (this._filterChanged || this.state.visits.length === 0) {
      this._filterChanged = false
      this.setState({ filterModalOpen: false }, this.fetchVisits)
    } else {
      this._filterChanged = false
      this.setState({ filterModalOpen: false })
    }
  }

  handleFilterChanged = (filters) => {
    this._filterChanged = true
    this.setState({ visitFilters: filters })
  }

  componentDidMount = () => {
    this.fetchVisits()
    this.fetchProducts()
    this.fetchPatients()
  }

  componentWillUnmount() {
  }

  // This will be triggered if the list of Visits is displayed and you click on the round '+' Button
  handleClickCreateVisit = async () => {
    const vDate = DATEOFVISIT
    this.setState({
        buttonText: 'SUBMIT',
        createOpen: true,
        dbinfo:'',
        displaySubMenuButtons:0,
        vDate,
    });

    this.handleChangePatient(null);
    
    if (!this.state.patients.length) {	  
      const route = `/patients/group/${this.props.groupId}`

      this.setState({ uiLoading: true })
  
      try {
        const response = await api.get(route);
        this.setState({ patients: response.data, uiLoading: false });
      } catch (error) {
          if (error.response.status === 403) {
            this.setState({login: true})
          }
          this.setState({ uiLoading: false })    
      }
    }
  }

  openVisitEditor () {

    this.setState({
      buttonText: 'SAVE',
      editOpen: true,
      dbinfo:'',
      displayVisit: true,
      mouseX: null,
      mouseY: null,
    })

    this.retrieveVoiceList(this.state.visitId)
  }

  handleCreateVisit = async (event) => {

    event.preventDefault()
    const data = this.state.visit
    data.date = this.state.vDate
    data.groupId = this.props.groupId
    data.createdBy = this.props.username
    try {
      // Adding visit
      this.setState({uiLoading:true})
      const response = await api.post(`/visit`,data)
      const visit = response.data

      // Display Visit as part of the Visits Table
      const visits = [...this.state.visits]
      visits.unshift(visit)
      this.setState({
        dbinfo:'Visit successfully created',
        createOpen: false,
        uiLoading: false,
        visits
      })

      // DEFAULT STOCK: Adding default Products to new visit
      const isCashVisit = String(visit.medicalAid || data.medicalAid || '')
        .trim()
        .toUpperCase() === 'CASH'

      if (isCashVisit) {
        const cashProduct = this.state.products.find(
          (product) => product.title === '88041 - PRIVATE WOUND DRESSING'
        )

        if (cashProduct) {
          this.handleCreateStockItem(cashProduct, visit.id)
        }
      } else {
        for (const product of this.state.products) {
          if (product.default) {
            this.handleCreateStockItem(product, visit.id)
          }
        }
      }
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({login: true})
      }
      else {
        this.setState({ uiLoading: false, createOpen: true })
        console.log(error)
      }
    }
  }


  handleUpdateVisit = async () => {

    const {id, ...uvisit} = this.state.visit

    this.setState({ uiLoading: true })

    try {
      await api.put(`/visit/${id}`, uvisit);
      
      this.setState({
        displayVisit: false,
        editOpen: false,
        dbinfo:'Visit successfully updated',
        uiLoading: false,
      })

    } catch (error) {
      if (error.response.status === 403) {
        this.setState({login: true})
      } else {
        this.setState({
          editOpen: true,
          uiLoading: false,
        })
      }
    }
  };

  confirmDeleteVisit = () => {
    if (this.props.isAdmin)
      this.setState({
        errors: {},
        mouseX: null,
        mouseY: null,
        deleteOpen: true,
      })
    }

  handleDeleteVisit = async () => {
    const visitId = this.state.visitId

    this.setState({
      deleteOpen: false,
      mouseX:null,
      mouseY:null,
      uiLoading:true
    })

    this.handleDeleteClinic(visitId)
    this.handleDeleteStockItems(visitId)
    this.deleteVoiceBatch(visitId)
    this.deletePhotoBatch(visitId)

    try {
      await api.delete(`/visit/${visitId}`);
      const visits = [...this.state.visits.filter((x) => x.id !== visitId)]
      this.setState ({ 
        visits:visits,
        dbinfo:'Visit successfully deleted',
        displaySubMenuButtons:0,
        uiLoading: false,          
      })
        // window.location.reload();
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({login: true})
      }
      else {
        this.setState({ 
          uiLoading: false
        })
        console.log(error)
      }
    }
  }


  // This function will be trigggered if a stock item should be added to the current visit
  handleCreateStockItem = async (product, visitId) => {
    if (product === null || product.title === '')
      return
     
    this.setState({uiLoading:true})
    try {
      const data = {
        product: product.title,
        quantity: 1,
        visitId
      }

      const response = await api.post(`/stockItem`, data )
      const stockItem = response.data
      const stockItems = [...this.state.stockItems]
      for (const y of this.state.products) {
        if (stockItem.product === y.title) {
          Object.assign(stockItem, {nappiCode: `${y.nappiCode}`})
          stockItems.push(stockItem)
        }
      }
      this.setState({
          uiLoading:false,
          stockItems
      })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({ login: true });
      } else {
 		this.setState({ uiLoading: false })
 		}
    }
  }

  handleUpdateStockItem = async (si) => {

    this.setState({uiLoading:true})
    try {
      const stockItem  = {
        visitId: si.visitId,
        product: si.product,
        quantity: +(si.quantity)
      }

      await api.put( `/stockItem/${si.id}`, stockItem )

      const stockItems = this.state.stockItems.map(x =>
        x.id === si.id ? si : x
      )
      this.setState({ stockItems, uiLoading:false })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({ login: true })
      }
      else {
        this.setState({ uiLoading: false })
      }
    }
  }

  openStockItemEditor = async () => {

    this.setState({
      buttonText: 'BACK',
      dbinfo:'',
      deleteItemOn: false,
      displayStockItems: true,
      editOpen: true,
      mouseX: null,
      mouseY: null,
    })

    this.setProductFilter()

    if (this.state.stockItems.length === 0) {
      try {
        const Id = this.state.visit['id']
        this.setState({ uiLoading: true })
        const response = await api.get (`/stockBatch/${Id}`)
        const stockItems = response.data
          .map(x => {
            const product = this.state.products.find(
              y => y.title === x.product
            )

            if (!product) return null

            return {
              ...x,
              nappiCode: String(product.nappiCode),
              quantity: x.quantity ?? 1
            }
          })
          .filter(Boolean)
        this.setState({ stockItems, uiLoading: false })
      } catch (error) {
          if (error.response.status === 403) {
            this.setState({ login: true })
          }
          else {
            this.setState({ uiLoading: false })
            console.log(error)
          }
      }
    }
  }

  setProductFilter = () => {
    let fp = []  
    if (this.state.visit['vac'] === '2') {
      fp = this.state.products.filter(product => product['category'] === STOMA)
    }
    else {
      fp = this.state.products.filter(product => product['category'] !== STOMA)
    }
    this.setState({filterProducts:fp})
  }

  handleDeleteStockItem = async () => {
    try {
      this.setState({ uiLoading: true })

      let stockItems = this.state.stockItems
      for (const stockItemId of this.state.selectedRows) {
        await api.delete(`/stockItem/${stockItemId}`)
        const si = stockItems.filter(x => x.id !== stockItemId)
        stockItems = si
      }

      this.setState({ stockItems, uiLoading: false })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState ({ login: true })
      }
      else {
        this.setState({ uiLoading: false })
        console.log(error)
      }
    }
    this.setState({ deleteItemOn: false, selectedRows: null })
  }

  handleDeleteStockItems = async (visitId) => {
    try {
      this.setState({ uiLoading: true })
      const response = await api.get(`/stockBatch/${visitId}`)

      if (response.data.length > 0)
        await api.delete(`/stockBatch/${visitId}`)

      this.setState({ uiLoading: false })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({ login: true })
      }
      else {
        console.log(error)
      }
    }
  }

  handleCreateOrUpdateClinic = async () => {
    if (this.state.comment === '')
      return

    const data = {
      author: this.props.username,
      visitId: this.state.visitId,
      comment: this.state.comment,
      date: this.state.visit['date'],
    }

    try {
      const clinicId = this.state.clinic['id']
      this.setState({ uiLoading: true })
      if (clinicId === 0) {
        const response = await api.post(`/clinic`, data)

        this.setState({
          buttonText:'SAVE',
          clinic: response.data,
          editOpen: true,
          uiLoading: false,
        })
      } else {
        await api.put(`/clinic/${clinicId}`, data)

        this.setState({
          displayClinic: false,
          editOpen: false,
          uiLoading: false,
        })
      }
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({ login: true })
      }
      else {
        this.setState({ 
          editOpen: true,
            uiLoading: false
        })
        console.log(error)
      }
    }
  }

  openClinicEditor = async () => {
    let clinic = {...clinic0}

    this.setState({
      displayClinic: true,
      editOpen: true,
      dbinfo:'',
      mouseX: null,
      mouseY: null,
      clinic
    })
    try { 
      let buttonText = 'SUBMIT'
      this.setState({ uiLoading: true })
      const response = await api.get (`/clinic/${this.state.visitId}`)

      if (response.data.length > 0) {
          clinic = response.data[0]
          buttonText = 'SAVE'
      }
      this.setState({
        comment: clinic.comment, uiLoading: false, buttonText, clinic 
      })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({ login: true })
      }
      else {
        this.setState({ uiLoading: false })
        console.log(error)
      }
    }
    this.retrieveImageList(this.state.visitId)
  }

  handleDeleteClinic = async (visitId) => {
    try {
      this.setState({uiLoading:true})
      const response = api.get(`/clinic/${visitId}`)
      if (response.data !== undefined && response.data.length > 0) {
        const clinicId = response.data[0].id
        await api.delete(`/api/clinic/${clinicId}`)
      }
      this.setState({ clinic:clinic0, uiLoading:false })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({ login: true })
      }
      else {
        console.log(error)
      }
    }
  }

  handleImageChange = (event) => {
    const allowedExtensions = ['jpg', 'jpeg', 'png'];
    const files = Array.from(event.target.files);
    const validFiles = files.filter((f) =>
      allowedExtensions.includes(f.name.split('.').pop().toLowerCase())
    );
    const skipped = files.length - validFiles.length;
    if (skipped > 0) {
      alert(`${skipped} file(s) skipped — only ${allowedExtensions.join(', ')} are allowed.`);
    }
    this.setState({
      imagesToUpload: validFiles,
      imageError: validFiles.length === 0 && files.length > 0,
    });
  };

  clinicImagesHandler = async (event) => {
    event.preventDefault();

    const { imagesToUpload, images, visitId, title } = this.state;
    if (!imagesToUpload.length) return;

    this.setState({ uiLoading: true, imageError: false });

    const newImages = [];
    try {
      for (let i = 0; i < imagesToUpload.length; i++) {
        const file = imagesToUpload[i];

        // Derive a per-image title: use title field as-is for one file,
        // or as a prefix ("Title 1", "Title 2") for multiple files.
        const baseName = file.name.replace(/\.[^.]+$/, '');
        const imageTitle =
          imagesToUpload.length === 1
            ? (title || baseName)
            : title
            ? `${title} ${i + 1}`
            : baseName;

        // Compress
        const compressedImage = await compressImage(file, {
          quality: 0.6,
          width: 1200,
          height: 1600,
        });

        // Build multipart payload
        const formData = new FormData();
        formData.append('image', compressedImage, compressedImage.name);

        // Upload via api instance (token injected by interceptor)
        const response = await api.post(
          `/clinic/image/${visitId}/${encodeURIComponent(imageTitle)}`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        const { id, imageUrl, title: rTitle, visitId: vId } = response.data;
        newImages.push({ id, imageUrl, title: rTitle, visitId: vId });
      }

      this.setState({
        images: [...images, ...newImages],
        editOpen: true,
        imagesToUpload: [],
        uiLoading: false,
        title: 'Wound Solutions',
      });
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true });
      } else {
        this.setState({
          imageError: error.response?.data?.error || 'Image upload failed',
          uiLoading: false,
        });
        console.error(error);
      }
    }
  };

  getSelectedPatientFromVisit = async () => {
    const selectedVisit = this.state.visit || {}
    const selectedSAID = String(selectedVisit.SAID || '').trim()
    if (!selectedSAID) return null

    let patient = (this.state.patients || []).find(
      (p) => String(p.SAID || '').trim() === selectedSAID
    )

    if (patient) return patient

    try {
      const response = await api.get(`/patients/${encodeURIComponent(selectedSAID)}`)
      if (Array.isArray(response.data) && response.data.length > 0) {
        patient = response.data[0]
        return patient
      }
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.log(error)
      }
    }

    return null
  }

  handleCreateOrUpdateAssessment = async () => {
    const patient = await this.getSelectedPatientFromVisit()
    const patientId = patient?.id || this.state.assessment?.patientId
    const SAID = patient?.SAID || this.state.assessment?.SAID || this.state.visit?.SAID || ''

    if (!patientId || !SAID) {
      this.setState({
        dbinfo: 'Select a visit linked to a patient first.',
        displayAssessment: false,
        editOpen: false,
      })
      return
    }

    try {
      this.setState({ uiLoading: true })

      const data = {
        ...this.state.assessment,
        patientId,
        SAID,
        visitId: this.state.visitId || this.state.assessment?.visitId || '',
      }

      if (data.id) {
        const assessmentId = data.id
        delete data.id
        await api.put(`/assessment/${assessmentId}`, data)
        data.id = assessmentId
      } else {
        delete data.id
        const response = await api.post('/assessment/patient', data)
        data.id = response.data.id
      }

      this.setState({
        assessment: data,
        displayAssessment: false,
        editOpen: false,
        uiLoading: false,
        dbinfo: 'Assessment saved',
      })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.log(error)
        this.setState({ editOpen: true })
      }
      this.setState({ uiLoading: false })
    }
  }

  // handleDeleteAssessment = async (visitId) => {

  //   try {
  //     this.setState({ uiLoading: true })
  //     const response = await api.get(`/assessment/${visitId}`)
  //     if (response.data.length > 0) {
  //       const assessmentId = response.data[0].id
  //       await api.delete(`/assessment/${assessmentId}`)
  //       this.setState({ clinic:clinic0, uiLoading:false })
  //     }
  //   } catch (error) {
  //     if (error.response.status === 403) {
  //       this.setState({ login: true })
  //     }
  //     else {
  //       this.setState({ uiLoading: false })
  //       console.log(error)
  //     }
  //   }
  // }

  openAssessmentEditor = async () => {
    this.setState({
      assessment: { ...assessment0 },
      patient: {},
      dbinfo: '',
      mouseX: null,
      mouseY: null,
    })

    const patient = await this.getSelectedPatientFromVisit()
    const patientId = patient?.id
    const SAID = patient?.SAID || this.state.visit?.SAID || ''

    if (!patientId || !SAID) {
      this.setState({
        dbinfo: 'Select a visit linked to a patient first.',
        displayAssessment: false,
        editOpen: false,
        patient: {},
      })
      return
    }

    try {
      this.setState({ uiLoading: true, patient })
      const response = await api.get(`/assessment/patient/${patientId}`)

      if (response.data.length > 0) {
        const assessment = { ...assessment0, ...response.data[0], patientId, SAID }
        this.setState({
          buttonText: 'SAVE',
          assessment,
          displayAssessment: true,
          editOpen: true,
          uiLoading: false,
        })
        return
      }

      const assessment = { ...assessment0, patientId, SAID, visitId: this.state.visitId || '' }
      this.setState({
        buttonText: 'SUBMIT',
        assessment,
        displayAssessment: true,
        editOpen: true,
        uiLoading: false,
      })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.log(error)
      }
      this.setState({ uiLoading: false })
    }
  }

  openAuth() {
    if (!this.state.visitId) {
      this.setState({
        dbinfo: 'Select a visit first',
        mouseX: null,
        mouseY: null,
      })
      return
    }

    this.setState({
      authDialogOpen: true,
      dbinfo:'',
      mouseX: null,
      mouseY: null,
    })
  }

  closeAuth() {
    this.setState({ authDialogOpen: false })
  }

  openInvoice() {
    if (!this.state.visitId) {
      this.setState({
        dbinfo: 'Select a visit first',
        mouseX: null,
        mouseY: null,
      })
      return
    }

    this.setState({
      invoiceDialogOpen: true,
      dbinfo:'',
      mouseX: null,
      mouseY: null,
    })
  }

  closeInvoice() {
    this.setState({ invoiceDialogOpen: false })
  }

  handleChangePatient = (patient) => {
    let visit = '' 
    if (patient !== null) {
      visit = {...this.state.visit}
      visit['patientName'] = patient['patientName']
      visit['firstName'] = patient['firstName']
      visit['SAID'] = patient['SAID']
      visit['medicalAid'] = patient['medicalAid']
      visit['memberNo'] = patient['memberNo']
    }
    else {
      visit = {...visit0} // classical side effect? This init doesn't matter with patient 
      // visit.seenBy = this.props.username // as per Kaitlin's request (March 2026), always initialize with Anita.
    }
    this.setState({ visit })
  }

  handleChangeItem = (event) => {
    const stockItem = this.state.stockItem
    stockItem[`${event.target.name}`] = event.target.value
    this.setState({ stockItem })
  }

  handleChangeVisit = (event) => {
    const visit = this.state.visit
    visit[`${event.target.name}`] = event.target.value
    this.setState({ visit })
  }

  handleChangeAssessment = (event) => {
    const assessment = this.state.assessment
    if (event.target.type === 'checkbox') {
      assessment[`${event.target.name}`] = event.target.checked
    } else {
      assessment[`${event.target.name}`] = event.target.value
    }
    this.setState({ assessment })
  }

  handleDeleteImage = (imageId) => {
    for (const image of this.state.images) {
      if (image.id === imageId) {
                        // derive file name from imageUrl
        this.deleteSingleImage(image)
        return
      }
    }
  }

  deleteSingleImage = async (image) => {
    let j = -10
    do {
      j -= 1
    } while(image.imageUrl.slice(j-1,j) !== '-' && j > -21)
    let imageFileName = image.visitId + image.imageUrl.slice(j-1,-10)
    // an ugly hack!

    imageFileName = imageFileName.replace('.','/')
    try {
      this.setState({ uiLoading: true })
      await api.delete(`/clinic/image/${image.id}/${imageFileName}`)
      const images = this.state.images.filter(m => m.id !== image.id)
      this.setState({ uiLoading:false, images })
    } catch (error) {
      if (error.response.status === 403) {
        this.setState({ login: true })
      }
      else {
        this.setState({ uiLoading:false })
        console.log(error)
      }
    }
  }
  
  deletePhotoBatch = async (visitId) => {
    try {
      const response = await api.get(`/photoBatch/${visitId}`)
      if (response.data.length > 0) {
        for (const image of response.data) {
          this.deleteSingleImage(image)
        }
      }
    } catch (error)  {
      if (error.response.status === 403) {
        this.setState({ login: true })
      }
      else {
        this.setState ({ 
          imageError: error.response.data,
        })
        console.log(error)
      }
    }
  }

  retrieveImageList = async (visitId) => {
    if (this.state.images.length === 0) {
      this.setState({ 
        imageLoading: true, 
        imageError: false 
      })
      let images = []
      try {
        const response = await api.get(`/photoBatch/${visitId}`)
        if (response.data.length > 0) {
          images = response.data
        }
        this.setState({
          imageLoading: false, 
          images
        })
      } catch (error) {
        if (error.response.status === 403) {
          this.setState({ login: true })
        } else {
          this.setState ({ 
            imageError: error.response.data, uiLoading: false 
          })
          console.log(error)
        }
      }
    }
  }

  handleUploadVoice = async (audioBlob, title) => {
    if (!audioBlob) {
      this.setState({ voiceError: 'No recording is available to upload.' })
      return false
    }

    if (audioBlob.size === 0) {
      this.setState({ voiceError: 'The recorded audio is empty. Please record again before uploading.' })
      return false
    }

    if (!this.state.visitId) {
      this.setState({ voiceError: 'Select a visit before uploading a voice note.' })
      return false
    }

    const safeTitle = title && title.trim() !== '' ? title.trim() : 'Voice Note'
    const encodedTitle = encodeURIComponent(safeTitle)
    const ext = audioBlob.type.includes('ogg')
      ? 'ogg'
      : audioBlob.type.includes('mpeg')
      ? 'mp3'
      : audioBlob.type.includes('mp4')
      ? 'mp4'
      : audioBlob.type.includes('wav')
      ? 'wav'
      : 'webm'

    const audioFile = new File([audioBlob], `voice-note.${ext}`, {
      type: audioBlob.type || 'audio/webm',
    })

    const formData = new FormData()
    formData.append('audio', audioFile, audioFile.name)
    formData.append('title', safeTitle)

    this.setState({ voiceError: '', voiceLoading: true })

    try {
      const response = await api.post(
        `/visit/voice/${this.state.visitId}/${encodedTitle}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )

      const voiceNotes = [response.data, ...this.state.voiceNotes]
      this.setState({ voiceError: '', voiceNotes, voiceLoading: false })
      return true
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        const message = error.response?.status === 404
          ? 'Voice upload API not found. Deploy the updated Firebase Functions and try again.'
          : error.response?.data?.error || 'Voice upload failed'
        this.setState({ voiceError: message, voiceLoading: false })
        console.error(error)
      }
      return false
    }
  }

  retrieveVoiceList = async (visitId) => {
    if (!visitId) return

    this.setState({ voiceError: '', voiceLoading: true })
    try {
      const response = await api.get(`/voiceBatch/${visitId}`)
      const voiceNotes = (response.data || []).sort((a, b) => {
        const at = a.createdAt || ''
        const bt = b.createdAt || ''
        return bt.localeCompare(at)
      })
      this.setState({ voiceError: '', voiceNotes, voiceLoading: false })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        const message = error.response?.status === 404
          ? 'Voice note API not found. Deploy the updated Firebase Functions and try again.'
          : error.response?.data?.error || 'Unable to load voice notes'
        this.setState({ voiceError: message, voiceLoading: false })
        console.error(error)
      }
    }
  }

  handleDeleteVoice = (voiceId) => {
    const voiceNote = this.state.voiceNotes.find((note) => note.id === voiceId)
    if (voiceNote) {
      this.deleteSingleVoice(voiceNote)
    }
  }

  deleteSingleVoice = async (voiceNote) => {
    if (!voiceNote.fileName) return

    this.setState({ voiceLoading: true })
    try {
      await api.delete(
        `/visit/voice/${voiceNote.id}/${encodeURIComponent(voiceNote.fileName)}`
      )
      const voiceNotes = this.state.voiceNotes.filter((note) => note.id !== voiceNote.id)
      this.setState({ voiceError: '', voiceNotes, voiceLoading: false })
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        this.setState({ voiceError: error.response?.data?.error || 'Unable to delete voice note', voiceLoading: false })
        console.error(error)
      }
    }
  }

  deleteVoiceBatch = async (visitId) => {
    try {
      const response = await api.get(`/voiceBatch/${visitId}`)
      if (response.data.length > 0) {
        for (const voiceNote of response.data) {
          await this.deleteSingleVoice(voiceNote)
        }
      }
    } catch (error) {
      if (error.response?.status === 403) {
        this.setState({ login: true })
      } else {
        console.error(error)
      }
    }
  }


  render() {
    if (this.state.login === true) {
      return <Redirect
        to={{ pathname: "/login" }}
      />
    }

    const { classes, ...rest } = this.props
    const { createOpen, deleteOpen, editOpen } = this.state

    const handleClose = async (event) => {
      this.setState({
        createOpen: false,
        deleteOpen: false,
        displayAssessment: false,
        displayClinic: false,
        displayStockItems: false,
        displayVisit: false,
        editOpen: false,
     })
    }

    const stockItemColumns = [
      {
        field: 'product',
        headerName: 'Product Title',
        width: 400,
        editable: false,
      },
      {
        field: 'nappiCode',
        headerName: 'Nappi Code',
        width: 200,
        editable: false,
      },
      {
        field: 'quantity',
        headerName: 'Quantity',
        width: 150,
        editable: true,
      },
    ]

    const visitColumns = [
      {
        field: 'date',
        headerName: 'Date',
        width: 100,
        editable: false,
      },
      {
        field: 'patientName',
        headerName: 'Surname',
        width: 140,
        editable: false,
      },
      {
        field: 'firstName',
        headerName: 'First Name',
        width: 140,
        editable: false,
      },
      {
        field: 'SAID',
        headerName: 'ID/Passport',
        width: 130,
        editable: false,
      },
      {
        field: 'medicalAid',
        headerName: 'Medical Aid',
        width: 120,
        editable: false,
      },
      {
        field: 'memberNo',
        headerName: 'Membership No.',
        width: 130,
        editable: false,
      },
      {
        field: 'home',
        headerName: 'Location',
        width: 110,
        editable: false,
        valueGetter: (params) => getHomeLabel(params.value)
      },
      {
        field: 'vac',
        headerName: 'vac',
        width: 110,
        editable: false,
        valueGetter: (params) => getVacLabel(params.value)
      },
      {
        field: 'seenBy',
        headerName: 'Seen by',
        width: 110,
        editable: false,
      },
      {
        field: 'admnotes',
        headerName: 'Admin Notes',
        width: 180,
        editable: false,
      },
      {
        field: 'notes',
        headerName: 'Notes',
        width: 120,
        editable: false,
      },
      {
        field: 'admin',
        headerName: 'Consumer Fee',
        width: 90,
        editable: false,
      },
    ]

    // Delete icon rendering moved into ClinicEditor; no inline DeleteNoDelete needed here
    
    // clinic images rendering moved into ClinicEditor presentational component

    const Error =
      this.state.error === false ? (
        <div className={classes.subTitle}>&nbsp;VISITS</div>
      ) : (
        <div className={classes.error}>Wrong Input!</div>
    )

    const clickToAddVisitButton = (
     <Tooltip title="Add a visit" placement="top">
      <IconButton
        className={classes.addButton}
        color="action"
        aria-label="Add a visit"
        onClick={this.handleClickCreateVisit}
        size="large">
        <AddCircleIcon style={{ fontSize: 60 }} />
      </IconButton>
     </Tooltip>
    )
  
    const clickToDeleteVisitButton = this.props.isAdmin ? (
     <Tooltip title="Delete a visit" placement="top">
      <IconButton
        className={classes.deleteButton}
        color="action"
        aria-label="delete visit"
        onClick={this.confirmDeleteVisit}
        size="large">
        <DeleteIcon style={{ fontSize: 60 }} />
      </IconButton>
     </Tooltip>
    ) : ''

  
    const clickToEditVisitButton = (
      <Button 
        variant="contained"
        aria-label="visit page"
        color="action" 
        startIcon={<EditIcon />}
        onClick={this.openVisitEditor}
        size="small"
      >
        Visit
      </Button>
    )
  
    const clickToEditStockItemsButton = (
      <Button
        variant="contained"
        color="action" 
        startIcon={<InventoryIcon />}
        onClick={this.openStockItemEditor}
        size="small"
      >
        Stock S.
      </Button>
    )
  
    const clickToEditClinicalButton = (
      <Button
        variant="contained"
        color="action"
        startIcon={<ShowChartIcon />}
        onClick={this.openClinicEditor}
        size="small"
      >
        Clinical
      </Button>
    )
  
    const clickToEditAssessmentButton = (
      <Button
        variant="contained"
        color="action"
        startIcon={<HealingIcon />}
        onClick={this.openAssessmentEditor}
        size="small"
      >
        Wound Ass.
      </Button>
    )

    const clickToFilterButton = (
      <Button
        variant="contained"
        color="action"
        startIcon={<FilterListIcon />}
        onClick={this.openFilterModal}
        size="small"
      >
        Filter
      </Button>
    )

    const clickToAuthButton = (
      <Button
        variant="contained"
        color="action"
        startIcon={<LaunchIcon />}
        onClick={this.openAuth}
        size="small"
        disabled={!this.state.visitId}
      >
        Auth.
      </Button>
    )

    const clickToInvoiceButton = (
      <Button
        variant="contained"
        color="action"
        startIcon={<ReceiptLongIcon />}
        onClick={this.openInvoice}
        size="small"
        disabled={!this.state.visitId}
      >
        Invoice
      </Button>
    )

    const dbinfo = this.state.dbinfo !== '' ? (
      <Button
        className={classes.floatingButton}
        color="action"
      >
        {this.state.dbinfo}  
      </Button>
    ) : ''
  
   
    const subMenuButtons = this.state.displaySubMenuButtons ? (
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
        {clickToAddVisitButton}
        {clickToFilterButton}
        {clickToEditVisitButton}
        {clickToEditStockItemsButton}
        {clickToEditClinicalButton}
        {clickToEditAssessmentButton}
        {clickToAuthButton}
        {clickToInvoiceButton}
        {clickToDeleteVisitButton}
        {dbinfo}
      </div>
    ) : (
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4 }}>
        {clickToAddVisitButton}
        {clickToFilterButton}
        {dbinfo}
      </div>
    )
  
  
    const handleCellEditStart = (e) => {
      const stockItem = {...e.row}
      this.setState({stockItem})
    }

    const handleCellEditCommit = (e) => {
      const stockItem = {...this.state.stockItem}
      stockItem.quantity = e.value
      this.handleUpdateStockItem(stockItem)
    }

    // const handleVisitSelectionChange = (e) => {
    //   this.setState({ deleteVisitOn: e.length > 0 })
    //   this.setState({ selectedRows: e })
    // }

    const handleItemSelectionChange = (e) => {
      this.setState({ deleteItemOn: e.length > 0})
      this.setState({ selectedRows: e})
    }

    const handleDoubleClick = (event) => {
      let mouseX = null
      let mouseY = null
      if (this.state.filterOff === true ) {
        mouseX = this.state.mouseX ? null : event.clientX - 2
        mouseY = this.state.mouseY ? null : event.clientY - 4
      }
      this.setState({
        displaySubMenuButtons:0,
        mouseX, 
        mouseY
      })
    }

    // const handleRightClick = (event) => {
    //   event.preventDefault()
    //   this.setState({
    //     mouseX: event.clientX - 2,
    //     mouseY: event.clientY - 4,
    //   })
    // }

    const handleSingleClick = (event) => {
      this.setState({
        dbinfo: '',
        displaySubMenuButtons:1
      })
    }

    const handleCMenuClose = () => {
      this.setState({
        mouseX: null,
        mouseY: null,
        displaySubMenuButtons:0
      })
    }

    const fetchKey = (event) => {
      if (this.state.visitId !== event.id) {
        this.setState({
          assessment:0,
          clinic:clinic0,
          images:[],
          patient: {},
          stockItems:[],
          visitId: event.id,
          visit: event.row,
          voiceNotes: [],
        })
      }
    }

    


    const toolbarTitle = (
      this.state.displayStockItems
      ? 'Update Stock Sheet'
      : this.state.displayClinic
      ? 'Update Clinical Record'
      : this.state.displayAssessment
      ? 'Update Wound Assessment'
      : this.state.displayVisit 
      ? 'Update Visit'
      : ''
    )

    const toolbarButton = ( 
      this.state.displayStockItems
      ?
      <Button
        color="inherit"
        onClick={handleClose}
        className={classes.submitButton}
      >
        {this.state.buttonText}
      </Button>
      : this.state.displayClinic 
      ?
        <Button
          color="inherit"
          onClick={this.handleCreateOrUpdateClinic}
          className={classes.submitButton}
        >
          {this.state.buttonText}
        </Button>
      : this.state.displayAssessment 
      ?
        <>
          <Button
            color="inherit"
            onClick={this.handleDownloadAssessmentPdf}
            style={{ position: 'absolute', right: 110 }}
          >
            Download PDF
          </Button>
          <Button
            color="inherit"
            onClick={this.handleCreateOrUpdateAssessment}
            className={classes.submitButton}
          >
            {this.state.buttonText}
          </Button>
        </>
      : this.state.displayVisit
      ?
      <Button
        color="inherit"
        onClick={this.handleUpdateVisit}
        className={classes.submitButton}
      >
        {this.state.buttonText}
      </Button>
      : ''
    )    

    

    const DeleteDialog = (
      <Dialog
        open={deleteOpen}
        onClose={handleClose}
      >
        <DialogContent>
          <DialogContentText>
              Please confirm this visit shall be deleted or cancel otherwise. 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={this.handleDeleteVisit}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    )

    // delete-stock-item button moved into StockSheet presentational component

    // Update visit info:
    const visitView = this.state.displayVisit ? (
      <VisitEditor
        classes={classes}
        visit={this.state.visit}
        onChange={this.handleChangeVisit}
        isAdmin={this.props.isAdmin}
        voiceError={this.state.voiceError}
        voiceNotes={this.state.voiceNotes}
        voiceLoading={this.state.voiceLoading}
        onUploadVoice={this.handleUploadVoice}
        onDeleteVoice={this.handleDeleteVoice}
      />
    ) : (
      ''
    )

    // Add/Delete stockItems per visit:
    const stockItemView = this.state.displayStockItems ? (
      <StockSheet
        classes={classes}
        filterProducts={this.state.filterProducts}
        productLoading={this.state.productLoading}
        stockItems={this.state.stockItems}
        columns={stockItemColumns}
        onAdd={(product) => this.handleCreateStockItem(product, this.state.visitId)}
        onCellEditStart={handleCellEditStart}
        onCellEditCommit={handleCellEditCommit}
        onSelectionChange={handleItemSelectionChange}
        deleteOn={this.state.deleteItemOn}
        onDeleteClick={this.handleDeleteStockItem}
      />
    ) : (
      ''
    )

    // Update clinical record entry per visit:
    const clinicView = this.state.displayClinic ? (
      <ClinicEditor
        classes={classes}
        rest={rest}
        comment={this.state.comment}
        onCommentChange={(v) => this.setState({ comment: v })}
        title={this.state.title}
        onTitleChange={(v) => this.setState({ title: v })}
        onFileChange={this.handleImageChange}
        imageError={this.state.imageError}
        onUpload={this.clinicImagesHandler}
        images={this.state.images}
        imageLoading={this.state.imageLoading}
        onDeleteImage={this.handleDeleteImage}
        isAdmin={this.props.isAdmin}
      />
    ) : (
      ''
    )

    // Update wound assessment data per visit
    const assessmentView = this.state.displayAssessment ? (
      <div ref={(el) => { this.assessmentEditorRef = el }}>
        <AssessmentEditor
          classes={classes}
          assessment={this.state.assessment}
          patient={{ ...(this.state.visit || {}), ...(this.state.patient || {}) }}
          onChange={this.handleChangeAssessment}
        />
      </div>
    ) : (
      ''
    )
    const vHeight = this.state.hMatches ? PHONEHEIGHT : this.state.pcMatches ? PCHEIGHT : TABHEIGHT
    const vWidth = this.state.wMatches ? PHONEWIDTH : this.state.pcMatches ? PCWIDTH : TABWIDTH
    
    const visitsToDisplay = this.state.visits

    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />

        {this.state.uiLoading && (
          <CircularProgress 
            size={150} 
            className={classes.uiProgess} 
            style={{left:'25%'}}
          />
        )}
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
          {Error}
          {subMenuButtons}
        </div>
        <div
          // onContextMenu={handleRightClick}
          onDoubleClick={handleDoubleClick}
          onClick={handleSingleClick}
          style={{ cursor: 'context-menu' }}
        >
          <VisitContextMenu
            mouseX={this.state.mouseX}
            mouseY={this.state.mouseY}
            onClose={handleCMenuClose}
            openVisitEditor={this.openVisitEditor}
            openStockItemEditor={this.openStockItemEditor}
            openClinicEditor={this.openClinicEditor}
            openAssessmentEditor={this.openAssessmentEditor}
            confirmDeleteVisit={this.confirmDeleteVisit}
            isAdmin={this.props.isAdmin}
          />
          {/* ### DataGrid to display available visits */}
          <div style={{ height: `${vHeight}pt`, width: `${vWidth}pt`, borderRadius: 20, overflow: 'hidden' }}>
            <DataGrid
              className={classes.visitGrid}
              rows={visitsToDisplay}
              columns={visitColumns}
              isRowSelectable={() => true}
              getRowClassName={(params) => {
                const medicalAid = String(params.row.medicalAid || '').trim().toUpperCase()
                if (medicalAid === 'CASH') return classes.visitCashRow
                const status = this.getVisitAuthStatus(params.row.SAID, params.row.date)
                if (status === 'authorized') return classes.visitAuthorizedRow
                if (status === 'pending') return classes.visitPendingRow
                if (status === 'declined') return classes.visitDeclinedRow
                return classes.visitNotStartedRow
              }}
              onCellClick={fetchKey}
            />
          </div>
        </div>
        {/* "Create-Visit" Dialog */}
        <Dialog
          fullScreen
          open={createOpen} 
          onClose={handleClose} 
          TransitionComponent={Transition} 
          PaperProps={{
            style: {
              backgroundColor: 'dialog',
              boxShadow: 'none',
            }
          }}
        >
          <AppBar position="sticky">
            <Toolbar 
              variant="dense"
            >
             <Tooltip title="Close Modal" placement="top">
              <IconButton
                autoFocus
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                size="large">
                <CloseIcon />
               </IconButton>
             </Tooltip>
             <Typography variant="h6" className={classes.title}>
                {'Create a new visit'}
             </Typography>
             <Button
//                  autoFocus
                color="inherit"
                onClick={this.handleCreateVisit}
                className={classes.submitButton}
             >
               {'Submit'}
             </Button>
            </Toolbar>
          </AppBar>
          {/* Small form to add patient details to visit: */}
          <form className={classes.form} noValidate>
            <Grid container>
              {/* <Grid item xs={9} sm={12}> */}
                <Autocomplete
                  id="patients"
                  autoHighlight
                  options={this.state.patients}
                  getOptionLabel={(option) => (option.patientName + ', ' + option.firstName + ', ' + option.SAID)}
                  style={{ width: 400 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="choose Patient"
                      variant="outlined"
                    />
                  )}
                  onChange={(event, patient) => {
                    this.handleChangePatient(patient)
                  }}
                />
              {/* </Grid> */}
            </Grid>
            <p/>
            <Grid container>
              <Grid item xs={6} sm={12}>
                <TextField
                  variant="outlined"
                  id="vDate"
                  label=""
                  helperText="Date of Visit"
                  type="date"
                  name="vDate"
                  value={this.state.vDate}
                  onChange={(e) => this.setState({ vDate: e.target.value })}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={1}>
              <Grid item xs={6}>
                <TextField
                  variant="filled"
                  disabled
                  id="patientName"
                  label=""
                  helperText="Name"
                  name="patientName"
                  value={this.state.visit['patientName']}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant="filled"
                  disabled
                  id="SAID"
                  label=""
                  helperText="ID/Passport number"
                  name="SAID"
                  value={this.state.visit['SAID']}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={1}>
              <Grid item xs={6}>
                <TextField
                  variant="filled"
                  disabled
                  id="medicalAid"
                  label=""
                  helperText="Medical Aid"
                  name="medicalAid"
                  value={this.state.visit['medicalAid']}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant="filled"
                  disabled
                  id="memberNo"
                  label=""
                  helperText="Member Number"
                  name="memberNo"
                  value={this.state.visit['memberNo']}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={1} >
              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="home"
                  label="Location"
                  name="home"
                  value={this.state.visit['home']}
                  onChange={this.handleChangeVisit}
                  select
                >
                  {HOME_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="vac"
                  label="Con/Vac"
                  name="vac"
                  value={this.state.visit['vac']}
                  onChange={this.handleChangeVisit}
                  select
                >
                  {VAC_OPTIONS.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
            <Grid container item xs={12} spacing={1} >
              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="admin"
                  label="Consumer Fee"
                  name="admin"
                  value={this.state.visit['admin']}
                  onChange={this.handleChangeVisit}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="seenBy"
                  label="Sr Seen By"
                  name="seenBy"
                  value={this.state.visit['seenBy']}
                  onChange={this.handleChangeVisit}
                />
              </Grid>
            </Grid>
            <div className={classes.formSeparator1}>
              <Typography variant="h6" className={classes.title}>
                {'Visit Notes'}
              </Typography>
              <TextareaAutosize
                style={{ width: '100%', fontSize: '14pt' }}
                minRows={5}
                maxRows={5}
                placeholder="type your visit notes here..."
                name="notes"
                value={this.state.visit['notes']}
                onChange={this.handleChangeVisit}
              />
            </div>
            <div className={classes.formSeparator1}>
              <Typography variant="h6" className={classes.title}>
                {'Admin Notes'}
              </Typography>
              <TextareaAutosize
                style={{ width: '100%', fontSize: '14pt' }}
                minRows={5}
                maxRows={5}
                placeholder="type your Admin notes here..."
                name="admnotes"
                value={this.state.visit['admnotes']}
                onChange={this.handleChangeVisit}
              />
            </div>
          </form>
        </Dialog>
        {/* Overlay to update visit, stock sheet, clinical record or wound assessment */}
        <Dialog
          fullScreen
          open={editOpen}
          onClose={handleClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              backgroundColor: '#ffefe0',
              boxShadow: 'none',
              overflowY: 'auto',
            }
          }}
        >
          <AppBar position="sticky">
              <VisitToolbar title={toolbarTitle} button={toolbarButton} onClose={handleClose} classes={classes} />
            </AppBar>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  className={classes.textField}
                  disabled
                  inputProps={{style: {backgroundColor: "#ffefe0", fontSize: 11}}}
                  InputLabelProps={{style: {fontSize: 10}}} 
                  variant="filled"
                  id="firstName"
                  label="First Name"
                  name="firstName"
                  value={this.state.visit['firstName']}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  inputProps={{style: {backgroundColor: "#ffefe0", fontSize: 11}}}
                  InputLabelProps={{style: {fontSize: 10}}} 
                  disabled
                  variant="filled"
                  id="patientName"
                  label="Last Name"
                  name="patientName"
                  value={this.state.visit['patientName']}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  inputProps={{style: {backgroundColor: "#ffefe0", fontSize: 11}}}
                  InputLabelProps={{style: {fontSize: 10}}} 
                  disabled
                  variant="filled"
                  id="SAID"
                  label="SA ID"
                  name="SAID"
                  value={this.state.visit['SAID']}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  inputProps={{style: {backgroundColor: "#ffefe0", fontSize: 11}}}
                  InputLabelProps={{style: {fontSize: 10}}} 
                  disabled
                  variant="filled"
                  id="memberNo"
                  label="Membership No."
                  name="memberNo"
                  value={this.state.visit['memberNo']}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  inputProps={{style: {backgroundColor: "#ffefe0", fontSize: 11}}}
                  InputLabelProps={{style: {fontSize: 10}}} 
                  disabled
                  variant="filled"
                  id="medicalAid"
                  label="Medical Aid"
                  name="medicalAid"
                  value={this.state.visit['medicalAid']}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  inputProps={{style: {backgroundColor: "#ffefe0", fontSize: 11}}}
                  InputLabelProps={{style: {fontSize: 10}}} 
                  disabled
                  variant="filled"
                  id="date"
                  label="Date of Visit"
                  name="date"
                  value={this.state.visit['date']}
                />
              </Grid>
            </Grid>
          {this.state.uiLoading && (
            <CircularProgress 
              size={75} 
              className={classes.uiProgess} 
              style={{left:'45%'}}
            />
          )}
          {visitView} {stockItemView} {clinicView} {assessmentView}
        </Dialog>
        <AuthorizationDialog
          mode="auth"
          open={this.state.authDialogOpen}
          onClose={this.closeAuth}
          onSessionExpired={() => this.setState({ login: true })}
          onEmailSent={() => this.fetchPatients()}
          groupId={this.props.groupId}
          visit={this.state.visit}
          products={this.state.products}
        />
        <AuthorizationDialog
          mode="invoice"
          open={this.state.invoiceDialogOpen}
          onClose={this.closeInvoice}
          onSessionExpired={() => this.setState({ login: true })}
          onEmailSent={() => this.fetchPatients()}
          groupId={this.props.groupId}
          visit={this.state.visit}
          products={this.state.products}
        />
        {DeleteDialog}
        <VisitFilterModal
          open={this.state.filterModalOpen}
          onClose={this.closeFilterModal}
          onChanged={this.handleFilterChanged}
          hasResults={this.state.visits.length > 0}
        />
      </main>
    );
  }
}

export default withStyles(styles)(visit)
